import styled from "styled";
import "./stylesheet.css";

/**
 * "The second font was developed by Indian Type Foundry (ITF). The ITF Rupee
 * font has 20 variations of the symbol. Each variation can be typed by pressing
 * keys from A to T. If you press A, the first variation of rupee symbol
 * appears; if you B, second variation will come; so on and so forth."
 *
 * @see https://techwelkin.com/download/rupee-symbol-font/
 */
export const RupeeFontSpan = styled.span`
  font-family: "itf_rupeeregular";
  font-size: 1.2em;
  font-weight: 600;
`;
